import type { ICompanyMSNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createCompanyMSNote,
  updateNote: updateCompanyMSNote,
  deleteNote: deleteCompanyMSNote,
} = makeNoteService<ICompanyMSNote>('/api/companymsnotes', 'companyMSNote')
